'use client'

import { useCallback } from 'react'
import { SEGMENT_DEPLOYABLE_NAME } from '@nwwp/utils'
import { useSegmentAnalytics, useSegmentTrackMeta } from '../components/Provider'
import type { NwStandardTrackInputMap } from '../generated'
import { buildStandardTrackPayload, EVENT_SCHEMA_KEYS, nestNonSchemaProps } from '../standard-track'

const UNKNOWN_PAGE_NAME = 'unknown'
const DEPLOYABLE_VERSION = '1.0.0'

export function useStandardTrack() {
  const analytics = useSegmentAnalytics()
  const { getPageviewId, getPageName } = useSegmentTrackMeta()

  return useCallback(
    <E extends keyof NwStandardTrackInputMap>(
      eventName: E,
      props: NwStandardTrackInputMap[E] & Record<string, unknown>
    ) => {
      const pageUrl = window.location.href
      const path = window.location.pathname
      const resolvedPageName = getPageName() || path || UNKNOWN_PAGE_NAME

      const stamped = buildStandardTrackPayload({
        eventName,
        deployableName: SEGMENT_DEPLOYABLE_NAME,
        deployableVersion: DEPLOYABLE_VERSION,
        pageviewId: getPageviewId(),
        pageName: resolvedPageName,
        pageUrl: pageUrl || path || UNKNOWN_PAGE_NAME,
        props: props as Record<string, unknown>,
      })

      return analytics.track(eventName as string, nestNonSchemaProps(stamped, EVENT_SCHEMA_KEYS[eventName]))
    },
    [analytics, getPageviewId, getPageName]
  )
}
